import { Col, Container, Row } from "react-bootstrap";
import { Tournament, tournamentStore } from "../Store/store";
import { useEffect, useState } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Overview: React.FC = () => {
  const nav = useNavigate();
  return (
    <Container style={{ minHeight: "80vh" }}>
      <Row
        style={{
          height: "100%",
          display: "flex",
          flexFlow: "column",
          justifyItems: "center",
          alignItems: "center",
          margin: "auto auto",
          marginBottom: "10vh",
        }}
      >
        <Col
          sm="12"
          md="12"
          style={{
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            justifyContent: "center",
            justifyItems: "center",
            minHeight: "100%",
            background: "transparent",
            margin: "auto auto",
          }}
        >
          <img src="data:image/jpeg;base64,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" />
          <h1 style={{ fontSize: 50 }}>
            It is not just a competition - we forging eSports legends.{" "}
            <span style={{ fontWeight: "bolder", color: "tomato" }}>
              We have been around paying players/gamers monthly.
            </span>{" "}
            <span style={{ color: "gray" }}>
              Select a tournament to view the log.
            </span>
            <_Selector
              onTournamentChange={(t) => {
                nav(`/_t/${t.id}`);
              }}
            />
          </h1>
        </Col>
        <Col sm="12" lg="6" md="6" xl="6">
          You have to{" "}
          <span style={{ textDecoration: "line-through" }}>play</span>{" "}
          <i>compete</i> to witness it.
        </Col>
        <Col sm="12" lg="6" md="6" xl="6">
          - WallOf
        </Col>
      </Row>
    </Container>
  );
};

const _Selector: React.FC<{ onTournamentChange: (t: Tournament) => void }> = ({
  onTournamentChange,
}) => {
  const [tournament, setTournament] = useState<Tournament | null>(
    tournamentStore.focusedTournament,
  );

  useEffect(() => {}, []);

  return (
    <FormControl fullWidth={false} variant="filled">
      <InputLabel id="demo-simple-select-label"></InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={tournament?.id}
        label=""
        onChange={(ev) => {
          console.log(ev.target.value);
          const id = tournamentStore.tournaments.find(
            (t) => t.id === ev.target.value,
          );
          if (id) {
            setTournament(id);
            tournamentStore.selectTournament(id);
            onTournamentChange(id);
          }
        }}
      >
        {tournamentStore.tournaments.map((t, index) => (
          <MenuItem value={t.id} key={index}>
            <label style={{ fontSize: "small" }}>{t.title}</label>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export { Overview };
